(() => {
  'use strict';
  if (window.ZypherImageRecovery) return;
  const report = window.ZypherImageRecovery = { version: '2026-10-25.2', attempted: 0, recovered: 0, exhausted: 0 };
  const states = new WeakMap();
  const queue = [];
  const prefix = '/s/files/1/0637/8179/8121/';
  let active = 0;

  function locationFor(value) {
    try {
      const url = new URL(value, document.baseURI);
      if (url.protocol !== 'https:') return null;
      if (url.hostname === 'cdn.shopify.com' && url.pathname.startsWith(prefix)) {
        return { url, key: url.pathname.slice(prefix.length) };
      }
      if (url.hostname === location.hostname && url.pathname.startsWith('/cdn/shop/')) {
        const key = url.pathname.slice('/cdn/shop/'.length);
        if (/^(files|products)\//.test(key)) return { url, key };
      }
    } catch (_) {}
    return null;
  }

  function sourceFor(img) {
    return locationFor(img.currentSrc || img.getAttribute('src') || '');
  }

  function isCurrent(state) {
    const source = sourceFor(state.img);
    return state.img.isConnected && !state.img.naturalWidth && states.get(state.img) === state && source && source.key === state.key;
  }

  function candidates(source) {
    const same = new URL(source.url);
    same.searchParams.set('_zypher_retry', '1');
    const alternate = new URL(source.url);
    if (alternate.hostname === 'cdn.shopify.com') {
      alternate.host = location.host;
      alternate.pathname = '/cdn/shop/' + source.key;
    } else {
      alternate.host = 'cdn.shopify.com';
      alternate.pathname = prefix + source.key;
    }
    alternate.searchParams.set('_zypher_retry', '2');
    const original = new URL('https://cdn.shopify.com' + prefix + source.key);
    const version = source.url.searchParams.get('v');
    if (version) original.searchParams.set('v', version);
    original.searchParams.set('_zypher_retry', '3');
    const final = new URL(original);
    final.host = location.host;
    final.pathname = '/cdn/shop/' + source.key;
    final.searchParams.set('_zypher_retry', '4');
    return [same.href, alternate.href, original.href, final.href];
  }

  function pump() {
    while (active < 4 && queue.length) {
      const state = queue.shift();
      state.queued = false;
      if (!isCurrent(state)) continue;
      active += 1;
      state.active = true;
      const url = state.urls[state.next++];
      report.attempted += 1;
      const probe = new Image();
      let timer;
      let settled = false;
      function finish(ok) {
        if (settled) return;
        settled = true;
        clearTimeout(timer);
        probe.onload = probe.onerror = null;
        active -= 1;
        state.active = false;
        if (isCurrent(state)) {
          if (ok) {
            state.done = true;
            const picture = state.img.closest('picture');
            if (picture) picture.querySelectorAll('source[srcset]').forEach(source => source.removeAttribute('srcset'));
            state.img.removeAttribute('srcset');
            state.img.src = url;
            state.img.dataset.zypherImageRecovery = 'recovered';
            report.recovered += 1;
          } else if (state.next < state.urls.length) {
            enqueue(state);
          } else {
            state.done = true;
            state.img.dataset.zypherImageRecovery = 'exhausted';
            report.exhausted += 1;
          }
        }
        pump();
      }
      probe.onload = () => finish(probe.naturalWidth > 0);
      probe.onerror = () => finish(false);
      timer = setTimeout(() => finish(false), 5000);
      probe.decoding = 'async';
      probe.src = url;
    }
  }

  function enqueue(state) {
    if (state.queued || state.active || state.done) return;
    state.queued = true;
    setTimeout(() => {
      queue.push(state);
      pump();
    }, 250 + state.next * 350);
  }

  function recover(img) {
    if (!(img instanceof HTMLImageElement) || img.naturalWidth > 0) return;
    const source = sourceFor(img);
    if (!source) return;
    let state = states.get(img);
    if (!state || state.key !== source.key) {
      state = { img, key: source.key, urls: candidates(source), next: 0, queued: false, active: false, done: false };
      states.set(img, state);
    }
    enqueue(state);
  }

  function inspect(root) {
    if (root instanceof HTMLImageElement && root.complete && !root.naturalWidth) recover(root);
    if (root.querySelectorAll) root.querySelectorAll('img').forEach(img => {
      if (img.complete && !img.naturalWidth) recover(img);
    });
  }

  document.addEventListener('error', event => recover(event.target), true);
  function start() {
    inspect(document);
    const pendingRoots = new Set();
    let scanQueued = false;
    new MutationObserver(records => {
      records.forEach(record => record.addedNodes.forEach(node => {
        if (node.nodeType === 1) pendingRoots.add(node);
      }));
      if (scanQueued || !pendingRoots.size) return;
      scanQueued = true;
      requestAnimationFrame(() => {
        scanQueued = false;
        const roots = new Set(Array.from(pendingRoots).filter(node => node.isConnected));
        pendingRoots.clear();
        roots.forEach(node => {
          for (let parent = node.parentElement; parent; parent = parent.parentElement) {
            if (roots.has(parent)) return;
          }
          inspect(node);
        });
      });
    }).observe(document.documentElement, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();

